// extracted by mini-css-extract-plugin
export default {"root":"LoungesContainer_root__16sNM","icon_root":"LoungesContainer_icon_root__oX9qx","header":"LoungesContainer_header__5tmL7"};